import { defaultHarmonyProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/harmony/default-constants';

export const TRADER_HARMONY_CONTRACT_ADDRESS = '0x24ad62502d1C652Cc7684081169D04896aC20f30';

export const TRADER_HARMONY_PROVIDER_CONFIGURATION = defaultHarmonyProviderConfiguration;
